import React from "react";
import { threeMReportApis } from "../../../../api/ThreeMReport";
import MonthlyScheduleDrawer from "../shared/MonthlyScheduleDrawer";

// Per-material monthly schedule. Presentation lives in the shared
// MonthlyScheduleDrawer; this only supplies the material's identity and fetch.

const MaterialMonthlyScheduleDrawer: React.FC<{
  open: boolean;
  projectId?: number | string;
  materialId?: number;
  materialName?: string;
  materialCode?: string;
  uomName?: string;
  phaseId?: number | string;
  activityId?: number | string;
  onClose: () => void;
  getContainer?: () => HTMLElement;
}> = ({
  open,
  projectId,
  materialId,
  materialName,
  materialCode,
  uomName,
  phaseId,
  activityId,
  onClose,
  getContainer,
}) => (
  <MonthlyScheduleDrawer
    open={open}
    itemName={materialName}
    itemCode={materialCode}
    uomName={uomName}
    entityLabel="material"
    fetchKey={
      projectId && materialId
        ? `${projectId}|${materialId}|${phaseId ?? ""}|${activityId ?? ""}`
        : ""
    }
    fetchSchedule={() =>
      threeMReportApis.get3MMaterialMonthlySchedule(
        projectId as number,
        materialId as number,
        { phaseId, activityId },
      )
    }
    onClose={onClose}
    getContainer={getContainer}
  />
);

export default MaterialMonthlyScheduleDrawer;
